import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import CartHeader from "containers/CartOverview/CartHeader/CartHeader";
import CartProducts from "containers/CartOverview/CartProducts/CartProducts";
import CartFooter from "containers/CartOverview/CartFooter/CartFooter";
import useCart from "hooks/useCart";
import withToasts from "hoc/withToasts";
import {
  createCartUniqueId,
  resetCartUnqiueId,
} from "store/actions/order.action";
import "containers/CartOverview/CartOverview.css";
import { APP_ROUTES } from "constants/routes";
import { useState } from "react";
import AlertModal from "components/AlertModal/AlertModal";
import { Link } from "react-router-dom";
import Button from "components/Button/Button";
import {
  requestDispenseLaterPostFetchApi,
  requestPostFetchApi,
} from "utils/apiMethods";
import { API_KEYS } from "constants/apiEndpoints";
import { getUserHashToken, getUserPhone } from "utils/commonMethods";
import { useSelector } from "react-redux";
function CartOverview({ history, showErrorToast }) {
  const componentTexts = window.appTexts.cart_page;
  const componentTexts2 = window.appTexts.checkout_page;

  const { currentCartItems } = useCart();
  const [showPaymentStatusModal, setShowPaymentStatusModal] = useState(false);
  const dispatch = useDispatch();
  const vendingMachineDetails = useSelector((state) => state.vmDetailsReducer);
  const [showDispenseLoader, setDispenseLoader] = useState(false);
  //if user clicks on dispense now button
  const onPaymentDispenseSuccess = function (cUID, backendOrderId) {
    // triggerPaymentStatusModal();
    // return syncCartApiCall(backendOrderId, gatewayOID).then(() => {
    return history.push(
      APP_ROUTES.DISPENSING_ITEMS.rawUrl + backendOrderId + "/" + cUID
    );
    // });
  };

  //it will call for dispense later api after the create cart api response if user had clicked on dispense later button
  const syncDispenseLaterCall = function (order_id) {
    return requestDispenseLaterPostFetchApi(API_KEYS.DISPENSE_LATER, {
      device_uuid: vendingMachineDetails.uuid,
      order_id,
      phone_no: getUserPhone(),
      hash: getUserHashToken(),
    });
  };

  //if user clicks on dispense later button
  const onPaymentDispenseLaterSuccess = function (cUID, backendOrderId) {
    setDispenseLoader(true);
    // triggerPaymentStatusModal();
    return syncDispenseLaterCall(backendOrderId).then((response) => {
      // "success": true,
      // "message": "Pickup code is: 6686",
      // "pickup_code": "6686"
      setDispenseLoader(false);
      if (response.success && response.pickup_code) {
        return history.push({
          pathname: APP_ROUTES.DISPENSE_LATER.url,
          state: {
            pickUp_code: response.pickup_code,
            oUID: backendOrderId,
          },
        });
      } else {
        triggerPaymentStatusModal(true);
      }
    });
  };
  const onPaymentFailure = function () {
    triggerPaymentStatusModal(true);
    // return syncCartApiCall(backendOrderId, gatewayOID, true);
  };

  const dispenseLaterHandler = function () {
    return history.push(APP_ROUTES.DISPENSE_LATER);
  };

  const triggerPaymentStatusModal = function (failure = false) {
    return setShowPaymentStatusModal({ failure });
  };

  //Handles cart unique id.
  useEffect(() => {
    if (currentCartItems.length > 0) {
      dispatch(createCartUniqueId());
    }

    return function () {
      if (currentCartItems.length === 0) {
        dispatch(resetCartUnqiueId());
      }
    };
  }, []);
  // showDispenseLoader ? (
  //   //   <div>
  //   //     <span className="loader"></span>
  //   //   </div>
  //   // )
  return (
    <React.Fragment>
      {showPaymentStatusModal ? (
        <AlertModal
          open={true}
          modalTitle={componentTexts2.unable_to_dispense_title}
          modalDescription={componentTexts2.unable_to_dispense_desc}
        >
          <Link to={APP_ROUTES.HOME_PAGE.url}>
            <Button className="mt-1">Go To Dashboard</Button>
          </Link>
        </AlertModal>
      ) : (
        <>
          <CartHeader componentTexts={componentTexts} />
          <section className="cart-page">
            <CartProducts />
            <CartFooter
              componentTexts={componentTexts}
              onPaymentDispenseSuccess={onPaymentDispenseSuccess}
              onPaymentDispenseLaterSuccess={onPaymentDispenseLaterSuccess}
              showPaymentStatusModal
              showDispenseLoader={showDispenseLoader}
              onPaymentFailure={onPaymentFailure}
              // dispenseLaterHandler={dispenseLaterHandler}
            />
          </section>
        </>
      )}
    </React.Fragment>
  );
}

export default withToasts(CartOverview);
